import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import ReactCodeInput from 'react-verification-code-input';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => {
  return {
    reactCodeInput: {
      width: '100%',
      '& div': {
        '& input': {
          // fontFamily: '"Nunito", "Manrope"',
          fontFamily: '"Roboto"',
          fontSize: '14px',
          [theme.breakpoints.down('xs')]: {
            fontSize: '12px',
          },
        },
      },
    },
  };
});

const ConfirmationCodeVerification = (
  {
    onVerify,
  },
) => {
  const codeInputClasses = useStyles();

  // TODO: Add this to useMediaQueries
  const sm = useMediaQuery((theme) => {
    return theme.breakpoints.down('xs');
  });

  const [ code, setCode ] = useState(null);

  const handleSubmit = () => {
    if (!code || !code.length || 6 !== code.length) {
      return;
    }
    if (!onVerify) {
      return;
    }
    onVerify(code);
  };

  return (
    <div>
      <Grid container>
        <ReactCodeInput
          className={ codeInputClasses.reactCodeInput }
          fieldWidth={ `${ 100 / 6 }%` }
          fieldHeight={ sm ? 56 : 56 }
          fields={ 6 }
          onChange={ (v) => {
            setCode(v);
          } }
        />
      </Grid>
      <Button
        disabled={ !code || !code.length || 6 !== code.length }
        fullWidth
        type='submit'
        variant='outlined'
        color='primary'
        autoFocus
        onClick={ () => {
          handleSubmit();
        } }
      >
        Confirm Code
      </Button>
    </div>
  );
};

export default ConfirmationCodeVerification;
